'use strict';
import * as $j_java$002elang$002e$002dEnum from "./java.lang.-Enum.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002eutil$002e$002dLocale$0024$002dCategory from "./java.util.-Locale$-Category.js";
import * as $j_scala$002eruntime$002e$002dEnum$002dValue from "./scala.runtime.-Enum-Value.js";
var $p;
/** @constructor */
function $c_ju_Locale$Category$$anon$3() {
  this.q = null;
  this.M = 0;
  $j_java$002elang$002e$002dEnum.$ct_jl_Enum__T__I__(this, "FORMAT", 1);
}
export { $c_ju_Locale$Category$$anon$3 as $c_ju_Locale$Category$$anon$3 };
$p = $c_ju_Locale$Category$$anon$3.prototype = new $j_java$002eutil$002e$002dLocale$0024$002dCategory.$h_ju_Locale$Category();
$p.constructor = $c_ju_Locale$Category$$anon$3;
/** @constructor */
function $h_ju_Locale$Category$$anon$3() {
}
export { $h_ju_Locale$Category$$anon$3 as $h_ju_Locale$Category$$anon$3 };
$h_ju_Locale$Category$$anon$3.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_ju_Locale$Category$$anon$3 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_ju_Locale$Category$$anon$3, "java.util.Locale$Category$$anon$3", ({
  nf: 1,
  ch: 1,
  n: 1,
  j: 1,
  a: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_ju_Locale$Category$$anon$3 as $d_ju_Locale$Category$$anon$3 };
